import { MobiDocument } from './MobiDocument';

export class ChampLibreValeurDocument extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private valeur: string;
    private champlibre_id: number;
    private ordre: number;


    public constructor(champLibreValeur: any) {
        super();
        this._id = champLibreValeur._id;
        this._rev = champLibreValeur._rev;
        this.id = champLibreValeur.id
        this.valeur = champLibreValeur.valeur
        this.champlibre_id = champLibreValeur.champlibre_id
        this.ordre = champLibreValeur.ordre
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getValeur(): string {
        return this.valeur;
    }

    public setValeur(valeur: string): void {
        this.valeur = valeur;
    }

    public getChamplibre_id(): number {
        return this.champlibre_id;
    }

    public setChamplibre_id(champlibre_id: number): void {
        this.champlibre_id = champlibre_id;
    }

    public getOrdre(): number {
        return this.ordre;
    }

    public setOrdre(ordre: number): void {
        this.ordre = ordre;
    }
}